"use strict";

var _slicedToArray = require("/var/www/ios-submodules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var server_1 = require("react-dom/server");

var acceptTypes = ["string", "number", "boolean"];

function createTable(_ref) {
  var header = _ref.header,
      body = _ref.body;
  var headers = react_1.default.createElement("tr", null, header.map(function (head) {
    return react_1.default.createElement("th", {
      key: head
    }, head);
  }));
  var bodies = body.map(function (val, i) {
    if (Array.isArray(val)) {
      return react_1.default.createElement("tr", {
        key: i
      }, val.map(function (value, i) {
        return react_1.default.createElement("th", {
          key: i
        }, " ", value, " ");
      }));
    }

    if (val !== null && typeof val === "object") {
      return react_1.default.createElement("tr", {
        key: i
      }, Object.entries(val).map(function (_ref2, i) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        if (typeof value === "object") {
          console.error("typeof ".concat(key, " is incorrect, only accept ").concat(acceptTypes.join(", "), " "));
          return react_1.default.createElement("th", {
            key: i
          });
        }

        return react_1.default.createElement("th", {
          key: i
        }, react_1.default.createElement(react_1.default.Fragment, null, value));
      }));
    }

    console.error("\n       data structure is incorrect,  \n       data structure type -> \n       \" type data = Array<{ [key: string]: string | number | boolean }> \n                         or \n        type data = Array<(string | number | boolean)[]>\"\n      ");
    return null;
  });
  return (0, server_1.renderToString)(react_1.default.createElement("table", null, react_1.default.createElement("tbody", null, headers, bodies)));
}

exports.default = createTable;